import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IhmEditableLabelComponent } from './ihm-editable-label.component';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MatIconModule, MatInputModule, MatTooltipModule],
  declarations: [IhmEditableLabelComponent],
  exports: [IhmEditableLabelComponent]
})
export class IhmEditableLabelModule {}
